<template>
  <Sticky>
    <nav class="navbar">
      <div class="navbar-container">
        <div class="navbar-side left">
          <ChangeLanguageDialog />
        </div>

        <!-- Center: Logo -->
        <div class="navbar-center">
          <img
            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/sabai88.webp"
            alt="Logo"
            @click="$router.push('/home')"
            class="logo"
          />
        </div>

        <div class="navbar-side right">
          <a href="https://t.me/sabai88th">
            <div
              v-if="$store.state.authUser.phone"
              class="icon-wrapper"
            
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M19.938 8H21a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8 8 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 0 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0M3 10v4h1v-4zm17 0v4h1v-4zM7.76 15.785l1.06-1.696A5.97 5.97 0 0 0 12 15a5.97 5.97 0 0 0 3.18-.911l1.06 1.696A7.96 7.96 0 0 1 12 17a7.96 7.96 0 0 1-4.24-1.215"
                />
              </svg>
            </div>
          </a>
          <div
            v-if="!$store.state.authUser.phone"
            @click="$router.push('/auth/login')"
            class="login-btn"
          >
            <p class="m-0">{{ $t('auth.login') }}</p>
          </div>
        </div>
      </div>
    </nav>
  </Sticky>
</template>

<script>
import { mapActions } from "vuex";
import { Toast, Dialog, Sticky } from "vant";
import ChangeLanguageDialog from "@/components/ChangeLanguageDialog.vue";

export default {
  components: {
    Sticky,
    ChangeLanguageDialog,
  },
  data() {
    return {
      authUser: null,
      isLogged: false,
    };
  },
  methods: {
    ...mapActions(["logoutUser", "fetchUser"]),
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure to log out?"
            : "ထွက်မှာ သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မထွက်တော့ပါ",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ",
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === "/home") this.$router.go();
          else {
            this.$router.push("/home");
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
          );
        })
        .catch(() => { });
    },
  },
  async mounted() {
    this.authUser = await this.fetchUser();
    if (this.authUser) this.isLogged = true;
  },
};
</script>

<style scoped>
.navbar {
  background-color: #3f1387 !important;
  border: none;
  padding: 8px 1rem;
}

.navbar-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.navbar-side {
  display: flex;
  align-items: center;
  min-width: 80px;
}

.navbar-side.right {
  justify-content: flex-end;
}

/* Centered Logo */
.navbar-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.logo {
  height: 4rem;
  object-fit: contain;
  cursor: pointer;
}

/* User Icon */
.icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: hsla(0, 0%, 100%, 0.1);
  color: #fff;
}

/* Login Button */
.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-radius: 22px;
  padding: 0 16px;
  margin-left: 10px;
  background: linear-gradient(to left, #924aff, #924aff);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 767.98px) {
  .navbar {
    padding: 6px 0.75rem;
  }

  .logo {
    height: 3.2rem;
  }
}
</style>
